import { getApiErrorMessage, getApiErrorStatus } from "../apiErrors";
import type { StoryItemSql, StoryItemSqlResponseApi } from "./storyItemSql.types";

/** What the dialog says while the endpoint isn't deployed (404 or 405). */
export const STORY_ITEM_SQL_UNAVAILABLE = "View SQL isn't available yet";
export const STORY_ITEM_SQL_LOAD_FAILED = "Couldn't load the SQL. Try again.";

/** The answer as the dialog reads it: every statement keyed, a blank message dropped. The SQL is never changed. */
export const mapStoryItemSql = (body: StoryItemSqlResponseApi): StoryItemSql => ({
  scope: body.scope,
  statements: (body.statements ?? []).map((statement, index) => ({
    key: `${index}:${statement.output ?? ""}`,
    output: statement.output ?? null,
    sql: statement.sql,
  })),
  message: body.message?.trim() ? body.message : null,
  modelName: body.model_name?.trim() ? body.model_name.trim() : null,
});

/**
 * One line for a failed request. 404 and 405: the endpoint isn't there yet. 409: the backend says why this
 * item has no SQL (it is not a chart on the new path), in its own words. Anything else: a plain retry line,
 * never the raw transport error.
 */
export const getStoryItemSqlErrorMessage = (error: unknown): string => {
  const status = getApiErrorStatus(error);
  if (status === 404 || status === 405) return STORY_ITEM_SQL_UNAVAILABLE;
  if (status === 409) return getApiErrorMessage(error, STORY_ITEM_SQL_LOAD_FAILED);
  return STORY_ITEM_SQL_LOAD_FAILED;
};
